const siteUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://www.carz.com.my';

/** @type {import('next-seo').DefaultSeoProps} */
export const SEO = {
  /**
   * Permit full size image previews, required for Google Discover to show article
   * images at full size.
   * The `googlebot` tag below is the load bearing one: page level <NextSeo> re-emits
   * `robots` and wins next/head de-duplication (last tag rendered wins), and
   * `robotsProps` is not latched into next-seo's module defaults. No page sets
   * `googlebot`, so it always survives, and Google prefers the more specific
   * user-agent token.
   */
  robotsProps: {
    maxImagePreview: 'large',
  },
  additionalMetaTags: [
    {
      name: 'googlebot',
      content: 'max-image-preview:large',
    },
  ],
  title:
    'Malaysia Automotive News: Latest, Car Launches, Reviews & Insights | Carz Automedia Malaysia',
  titleTemplate:
    'Malaysia Automotive News: Latest, Car Launches, Reviews & Insights | Carz Automedia Malaysia',
  description:
    'Search for new cars, used cars & recon cars on Carz.com.my! - an up & coming online car buying site in Malaysia. Find your next car and stay up-to-date with the latest news, launches, car prices, and more!',
  openGraph: {
    type: 'website',
    url: siteUrl,
    siteName: 'Carz Automedia Malaysia',
    title:
      'Malaysia Automotive News: Latest, Car Launches, Reviews & Insights | Carz Automedia Malaysia',
    description:
      'Search for new cars, used cars & recon cars on Carz.com.my! - an up & coming online car buying site in Malaysia. Find your next car and stay up-to-date with the latest news, launches, car prices, and more!',
    images: [
      {
        url: `${siteUrl}/carz-automedia-logo.png`,
        alt: 'Carz Automedia',
        type: 'image/png',
      },
    ],
  },
};

export default SEO;
